module.exports = "/images/vendor/desiigner-svg/svg/ui/checked.svg?a88ca7dcfebae2421a0808f075a9451d";